import { Tag } from 'src/services/tag/Tag';

export function getTopLevelTag<T extends Tag>(
  tag: T,
  tags: T[]
): T | undefined {
  // debug here
  const topLevelPath = tag.fullPath.split('/')[0];
  const topLevelTag = tags.find((t) => t.fullPath === topLevelPath);
  if (topLevelTag) {
    return topLevelTag;
  } else {
    return tag;
  }
}

export function getTopLevelTagByFullPath<T extends Tag>(
  fullPath: string,
  tags: T[]
): T | undefined {
  // debug here
  const topLevelPath = fullPath.split('/')[0];
  return tags.find((t) => t.fullPath === topLevelPath);
}
